import { authHref } from '@/shared/lib/auth-return';
import Link from 'next/link';

export function BackToLoginLink({
	redirectPath,
}: { redirectPath?: string } = {}) {
	return (
		<div className="flex flex-row justify-center gap-1 text-center text-sm text-gray-600">
			Уже есть аккаунт?
			<Link
				href={authHref('/login', redirectPath)}
				className="text-primary hover:text-primary-darken font-medium"
			>
				Войти
			</Link>
		</div>
	);
}
